module.exports = __webpack_public_path__ + "82815a1be4bd46bc80d6d34271708a07.pdf";